<div>
  <h4 class="db-cdn-full-page-cache-toggle__title">Full page cache</h4>
  <p class="db-cdn-full-page-cache-toggle__desc mt4">Cache the HTML content of your pages.</p>
</div>
<div *ngIf="!cdnDisabled;">
  <input class="ds-switcher-green ds-control-small" type="checkbox" id="pageCache" [disabled]="loading" [checked]="!pageCacheDisabled"
         [ngModel]="!pageCacheDisabled">
  <label for="pageCache" (click)="togglePageCache(pageCacheDisabled = !pageCacheDisabled); $event.preventDefault()">
    <span class="ds-switcher-control"></span>
  </label>
</div>
<div class="db-unavailable-text" *ngIf="cdnDisabled">Enable Enterprise CDN to apply full page cache</div>
